import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Inquiry from "./pages/Inquiry";
import Admin from "./pages/Admin";
import ThankYou from "./pages/ThankYou";
import Start from "./pages/Start";
import Schedule from "./pages/Schedule";
import StudioLogin from "./pages/StudioLogin";
import StudioLayout from "./pages/StudioLayout";
import StudioHome from "./pages/StudioHome";
import StudioMessages from "./pages/StudioMessages";
import StudioPerks from "./pages/StudioPerks";
import StudioSettings from "./pages/StudioSettings";
import StudioProfile from "./pages/StudioProfile";
import StudioFinishSignup from "./pages/StudioFinishSignup";
import Chords from "./pages/Chords";
import RequireStudioAccess from "./components/RequireStudioAccess";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/start" element={<Start />} />
          <Route path="/inquiry" element={<Inquiry />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route
            path="/chords"
            element={
              <RequireStudioAccess
                toolName="Chord Atlas"
                description="A movable-shape companion built on CAGED logic — browse every neck position for any progression, or look up the five ways to grab a single chord."
              >
                <Chords />
              </RequireStudioAccess>
            }
          />
          <Route path="/admin" element={<Admin />} />
          <Route path="/studio/login" element={<StudioLogin />} />
          <Route path="/studio/finish-signup" element={<StudioFinishSignup />} />
          <Route path="/studio" element={<StudioLayout />}>
            <Route index element={<StudioHome />} />
            <Route path="messages" element={<StudioMessages />} />
            <Route path="profile" element={<StudioProfile />} />
            <Route path="settings" element={<StudioSettings />} />
            <Route
              path="perks"
              element={<StudioPerks />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
